import APP_DEFAULTS from '../constants/app-defaults';
import spreeStore from '../store';

const ZoneService = {
    getNameCurrentZone: (availableZones, currentZone) => {
        const sanitizedZone = (availableZones || []).find((z) => z.id === currentZone);
        return (sanitizedZone) ? sanitizedZone.name : 'Cuba - La Habana';
    },
    isDonationZone: () => {
        const state = spreeStore.getState();
        return state.configs.donation.zone === state.zones.currentZone;
    },
    isCurrentZoneCuba: () => {
        const state = spreeStore.getState();
        const currentZone = state.zones.availableZones.find((zone) => zone.id === state.zones.currentZone);
        if (currentZone === undefined) {
            throw new Error('Current zone id not found in available zones');
        }
        return currentZone.countries_iso.indexOf(APP_DEFAULTS.countryIsoCuba) > -1;
    },
};

export default ZoneService;



/** WEBPACK FOOTER **
 ** ./src/services/zone-service.js
 **/